/* tslint:disable */

/**
 */
export class Template {
    template_type?: string;
}
